export const FEEDBACK_INVITATION_EXCLUSIONS = Object.freeze({
  LOGIN: "login",
  WELCOME: "welcome",
  LEGAL: "legal",
  TUTORIAL: "tutorial",
  ADMIN: "admin",
});

export const getFeedbackInvitationExclusion = ({
  showAuth,
  showPasswordReset,
  showRegister,
  showWelcome,
  showExplore,
  showPolicies,
  legalDocument,
  showOnboarding,
  adminTutorialOpen,
  showAdmin,
  adminPreview,
  adminEditPlace,
  adminImageViewer,
}) => {
  if (showAuth || showPasswordReset || showRegister) return FEEDBACK_INVITATION_EXCLUSIONS.LOGIN;
  if (showWelcome || showExplore) return FEEDBACK_INVITATION_EXCLUSIONS.WELCOME;
  if (showPolicies || legalDocument) return FEEDBACK_INVITATION_EXCLUSIONS.LEGAL;
  if (showOnboarding || adminTutorialOpen) return FEEDBACK_INVITATION_EXCLUSIONS.TUTORIAL;
  if (showAdmin || adminPreview || adminEditPlace || adminImageViewer) return FEEDBACK_INVITATION_EXCLUSIONS.ADMIN;
  return null;
};
